import { BLOCK_CLASSES } from '@intercom/embercom-prosemirror-composer/lib/blocks/constants';
import { stylable } from '../decorators';
export const calloutSpec = stylable({
  inline: false,
  content: '(block | list)*',
  group: 'block',
  selectable: false,
  attrs: {
    type: {
      default: 'callout'
    }
  },
  parseDOM: [{
    tag: `.${BLOCK_CLASSES.callout}`
  }],
  toDOM(_node) {
    return ['div', {
      class: `${BLOCK_CLASSES.callout}`,
      'data-insertable': 'true'
    }, 0];
  }
});